import React, { useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import api from "../api";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const authCode = urlParams.get("code");

    if (authCode) {
      api.post("/google-auth/", { code: authCode })
        .then((response) => {
          localStorage.setItem("access_token", response.data.access_token);
          navigate("/dashboard");
        })
        .catch((error) => {
          console.error("Error exchanging code for token:", error);
          navigate("/login");
        });
    }
  }, [location, navigate]);

  const handleGoogleLogin = () => {
    window.location.href = "https://api.astrotrader.xyz/accounts/google/login/?process=login";
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-heroBg text-white p-6">
      <div className="bg-white p-8 rounded-2xl shadow-2xl border border-gold w-full max-w-md text-center">
        <h1 className="text-3xl md:text-4xl font-extrabold text-[#041c16] mb-3 tracking-wide">
          Login to Astro Trader
        </h1>
        <p className="text-gray-600 mb-6 text-sm md:text-base">
          Sign in to access your cosmic insights.
        </p>
        <button
          onClick={handleGoogleLogin}
          className="w-full px-6 py-3 bg-gold text-[#041c16] font-bold rounded-lg shadow-md hover:scale-105 hover:shadow-lg transition-all duration-300"
        >
          🚀 Sign in with Google
        </button>
        <Link
          to="/"
          className="mt-6 inline-block text-sm text-gold hover:underline transition duration-300"
        >
          ← Back to Home
        </Link>
      </div>
    </div>
  );
};

export default Login;
